<template>
  <div class="table-fileds-wrap">
    <button class="btn btn-primary btn-micro" v-b-toggle.sidebar-table-fields>
      <div class="btn-with-icon-content">
        <i class="el-icon-setting" style="margin-right:10px;"></i>
        Settings
      </div>
    </button>
    <b-sidebar
      id="sidebar-table-fields"
      title="Table Fileds Settings"
      backdrop
      right
      shadow
    >
      <b-form-group label="Visible fields">
        <b-form-checkbox
          v-for="option in filedsOptions"
          :key="option.key"
          v-model="selected"
          :value="option.key"
          name="flavour-3a"
          @change="$emit('onRefetchTableColumns', option, selected)"
        >
          {{ option.label }}
        </b-form-checkbox>
      </b-form-group>
    </b-sidebar>
  </div>
</template>
<script>
import {
  BButton,
  BSidebar,
  VBToggle,
  BFormCheckbox,
  BFormGroup,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
export default {
  components: {
    BButton,
    BSidebar,
    VBToggle,
    BFormCheckbox,
    BFormGroup,
  },
  directives: {
    Ripple,
    "b-toggle": VBToggle,
  },
  props: {
    filedsOptions: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      selected: [],
    };
  },
  created() {
    this.selected = this.filedsOptions.map((v) => v.key);
  },
};
</script>
<style lang="scss">
.table-fileds-wrap {
  width: 100%;
  margin-bottom: 10px;
}
#sidebar-table-fields {
  .b-sidebar-header {
    padding: 1rem !important;
    font-size: 16px;
  }
  .b-sidebar-body {
    padding: 1.5rem;
    background-color: #fff;
    .custom-checkbox {
      margin-bottom: 0.5rem;
    }
  }
}
.table-fileds-wrap {
  .b-sidebar-outer {
    z-index: 9999 !important;
  }
}
</style>